const helper = {
  getRiskMinMaxRange: ({ modelportfolios }) => {
    if (modelportfolios && modelportfolios.length > 0) {
      let obj = {};

      let idAssociatedValue = {};

      let arr = [];
      for (let i = 0; i < modelportfolios.length; i++) {
        let val =
          modelportfolios[i]["data"][0]["optimization_params"]["max_vol"] * 1;

        let id = modelportfolios[i]["id"];
        arr.push(val);

        idAssociatedValue[id] = val;
      }

      obj["min"] = arr.length ? Math.min(...arr) : 0;
      obj["max"] = arr.length ? Math.max(...arr) : 0;
      obj["idAssociatedValue"] = idAssociatedValue;
      return obj;
    }
  },

  getUniqueID: () => {
    return Math.floor(Math.random() * Date.now());
  },
};

export default helper;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/helper.js